import { render, staticRenderFns } from "./ConfirmAccount.vue?vue&type=template&id=3db0bff3&scoped=true"
import script from "./ConfirmAccount.vue?vue&type=script&lang=ts"
export * from "./ConfirmAccount.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmAccount.vue?vue&type=style&index=0&id=3db0bff3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db0bff3",
  null
  
)

export default component.exports